import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import {
  FaSearch,
  FaBullhorn,
  FaChartLine,
  FaInstagram,
  FaEnvelopeOpenText,
} from "react-icons/fa";

export default function Digi() {
  const navigate = useNavigate();

  const services = [
    {
      icon: <FaSearch />,
      title: "SEO Optimization",
      desc: "Improve rankings and get organic traffic from Google.",
    },
    {
      icon: <FaBullhorn />,
      title: "Paid Ads",
      desc: "High-converting Google & Meta ad campaigns.",
    },
    {
      icon: <FaChartLine />,
      title: "Performance Marketing",
      desc: "Data-driven strategies that maximize ROI.",
    },
    {
      icon: <FaInstagram />,
      title: "Social Media",
      desc: "Grow your brand across Instagram & platforms.",
    },
    {
      icon: <FaEnvelopeOpenText />,
      title: "Email Marketing",
      desc: "Convert leads with automated campaigns.",
    },
  ];

  return (
    <div className="bg-white text-gray-900 min-h-screen">
      <Header />

      {/* 🔥 HERO (SAME STYLE - UPDATED CONTENT) */}
      <section className="max-w-6xl mx-auto px-6 py-24 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight leading-tight">
            Grow your business with <br />
            digital marketing
          </h1>

          <p className="mt-5 text-gray-500 max-w-xl mx-auto">
            We help brands scale with SEO, ads, and data-driven strategies that deliver real results.
          </p>

          <button
            onClick={() => navigate("/contact")}
            className="mt-8 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
          >
            Get Free Strategy →
          </button>
        </motion.div>
      </section>

      {/* 💎 SERVICES (SAME GRID STYLE) */}
      <section className="max-w-6xl mx-auto px-6 pb-24 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {services.map((s, i) => (
          <motion.div
            key={i}
            whileHover={{ y: -4 }}
            className="group p-6 rounded-2xl border border-gray-200 hover:border-gray-300 transition bg-white"
          >
            <div className="text-2xl text-gray-800 mb-4">
              {s.icon}
            </div>

            <h3 className="text-lg font-semibold mb-2">
              {s.title}
            </h3>

            <p className="text-sm text-gray-500">
              {s.desc}
            </p>

            <button
              onClick={() => navigate("/quotes")}
              className="mt-4 text-sm text-black font-medium hover:underline"
            >
              Learn more →
            </button>
          </motion.div>
        ))}
      </section>

      {/* 🚀 EXTRA SECTION (SMALL UNIQUE TOUCH) */}
      <section className="bg-gray-50 py-20 text-center px-6">
        <h2 className="text-3xl font-semibold">
          Results that matter 🚀
        </h2>

        <p className="mt-4 text-gray-500 max-w-xl mx-auto">
          We focus on real growth — more traffic, better leads, and higher conversions.
        </p>
      </section>

      {/* 🚀 CTA (SAME STYLE) */}
      <section className="border-t border-gray-200 py-20 text-center">
        <h2 className="text-3xl font-semibold">
          Ready to grow your business?
        </h2>

        <button
          onClick={() => navigate("/contact")}
          className="mt-6 px-8 py-3 bg-black text-white rounded-full font-semibold hover:opacity-80 transition"
        >
          Contact Us
        </button>
      </section>

      <Footer />
    </div>
  );
}